
function updateParallax() {
  const containers = document.querySelectorAll('.parallax_container');

  containers.forEach(container => {
    const img = container.querySelector('img');
    const rect = container.getBoundingClientRect();
    const scrollTop = window.scrollY || window.pageYOffset;

    const speed = 0.15; // smaller = slower parallax
    const containerOffsetTop = container.offsetTop;
    const distance = scrollTop - containerOffsetTop;

    // Calculate translateY ensuring image always covers container
    const maxTranslate = (img.offsetHeight - container.offsetHeight);
    const translateY = Math.max(Math.min(distance * speed, maxTranslate), 0);

    img.style.transform = `translateY(-${translateY}px)`;
  });
}

// Optimize scroll event with requestAnimationFrame
let ticking = false;
window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      updateParallax();
      ticking = false;
    });
    ticking = true;
  }
});